import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { SubscriptionStore } from './stores/subscription.store';
import { OptInStore } from 'src/marketing/stores/opt-in.store';

export const marketingContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(marketingContainer);

marketingContainer.bind(SubscriptionStore).toSelf().inSingletonScope();
marketingContainer.bind(OptInStore).toSelf().inSingletonScope();
